import { MutationCache, QueryCache, QueryClient, type DefaultOptions } from '@tanstack/react-query';
import { ApiError } from './api';
import { discardAuthenticatedCache } from './auth';

const defaultOptions: DefaultOptions = {
  queries: { staleTime: 15_000, retry: shouldRetryQuery, refetchOnWindowFocus: false },
  mutations: { retry: false },
};

export function shouldRetryQuery(failureCount: number, error: Error): boolean {
  if (error instanceof ApiError && error.status >= 400 && error.status < 500) return false;
  return failureCount < 1;
}

export function createAppQueryClient(): QueryClient {
  const handleError = (error: Error) => {
    if (error instanceof ApiError && error.status === 401) {
      discardAuthenticatedCache(queryClient);
    }
  };

  const queryClient = new QueryClient({
    queryCache: new QueryCache({ onError: handleError }),
    mutationCache: new MutationCache({ onError: handleError }),
    defaultOptions,
  });
  return queryClient;
}
